const FULLSCREEN_API_OPTIONS = {
  fullscreenEnabled: 0,
  fullscreenElement: 1,
  requestFullscreen: 2,
  exitFullscreen: 3,
  fullscreenchange: 4,
  fullscreenerror: 5,
  fullscreen: 6,
}

const WEBKIT_PREFIXES = [
  "webkitFullscreenEnabled",
  "webkitFullscreenElement",
  "webkitRequestFullscreen",
  "webkitExitFullscreen",
  "webkitfullscreenchange",
  "webkitfullscreenerror",
  "-webkit-full-screen",
]

const MOZ_PREFIXES = [
  "mozFullScreenEnabled",
  "mozFullScreenElement",
  "mozRequestFullScreen",
  "mozCancelFullScreen",
  "mozfullscreenchange",
  "mozfullscreenerror",
  "-moz-full-screen",
]

const MS_PREFIXES = [
  "msFullscreenEnabled",
  "msFullscreenElement",
  "msRequestFullscreen",
  "msExitFullscreen",
  "MSFullscreenChange",
  "MSFullscreenError",
  "-ms-fullscreen",
]

// so it doesn't throw error if no window or document
const document = typeof window !== "undefined" && typeof window.document !== "undefined" ? window.document : {}

const vendor =
  ("fullscreenEnabled" in document && Object.keys(FULLSCREEN_API_OPTIONS)) ||
  (WEBKIT_PREFIXES[0] in document && WEBKIT_PREFIXES) ||
  (MOZ_PREFIXES[0] in document && MOZ_PREFIXES) ||
  (MS_PREFIXES[0] in document && MS_PREFIXES) ||
  []

export default {
  requestNativeFullscreen: (element) => element[vendor[FULLSCREEN_API_OPTIONS.requestFullscreen]](),
  requestNativeFullscreenFunction: (element) => element[vendor[FULLSCREEN_API_OPTIONS.requestFullscreen]],
  addEventListener: (type, handler, options) => {
    document.addEventListener(vendor[FULLSCREEN_API_OPTIONS[type]], handler, options)
  },
  get exitNativeFullscreen() {
    return document[vendor[FULLSCREEN_API_OPTIONS.exitFullscreen]].bind(document)
  },
  get fullscreenPseudoClass() {
    return `:${vendor[FULLSCREEN_API_OPTIONS.fullscreen]}`
  },
  get isFullscreenModeSupported() {
    return Boolean(document[vendor[FULLSCREEN_API_OPTIONS.fullscreenEnabled]])
  },
  get getFullscreenElement() {
    return document[vendor[FULLSCREEN_API_OPTIONS.fullscreenElement]]
  },
  get isFullscreen() {
    return !!document[vendor[FULLSCREEN_API_OPTIONS.fullscreenElement]]
  },
}
